export function getWeeklyDateRange(weekType: 'current' | 'next' = 'current'): {
  fromDate: string;
  toDate: string;
} {
  const now = new Date();

  // Get IST offset (UTC+5:30 = 330 minutes)
  const istOffset = 5.5 * 60 * 60 * 1000;
  const istTime = new Date(now.getTime() + istOffset);

  const day = istTime.getUTCDay();

  // Calculate start of week in IST
  const startOfWeek = new Date(istTime);
  startOfWeek.setUTCDate(istTime.getUTCDate() - day);
  startOfWeek.setUTCHours(0, 0, 0, 0);

  if (weekType === 'next') {
    startOfWeek.setUTCDate(startOfWeek.getUTCDate() + 7);
  }

  // Calculate end of week in IST
  const endOfWeek = new Date(startOfWeek);
  endOfWeek.setUTCDate(startOfWeek.getUTCDate() + 6);
  endOfWeek.setUTCHours(23, 59, 59, 999);

  // Convert back to actual UTC by subtracting IST offset
  const fromDateUTC = new Date(startOfWeek.getTime() - istOffset);
  const toDateUTC = new Date(endOfWeek.getTime() - istOffset);

  return {
    fromDate: fromDateUTC.toISOString(),
    toDate: toDateUTC.toISOString(),
  };
}
